import type { QueryClient } from "@tanstack/react-query";

/**
 * localStorage key recording which user the persisted cache belongs to, so a
 * different user (or a logged-out fresh load) on the same browser can be detected
 * and their predecessor's data wiped before it's shown.
 */
export const CACHE_OWNER_KEY = "greenlight.cache-owner";

/** The bit of the persister clearClientCache needs (the sync-storage persister). */
type CachePersister = { removeClient: () => unknown };

/**
 * Wipe BOTH the in-memory Query cache and the on-disk (localStorage) snapshot.
 * queryClient.clear() only empties memory — without removeClient() the persisted
 * copy survives and the next user on the same browser rehydrates the previous
 * user's data (notifications feed, unread badge, board) for up to 24h.
 */
export function clearClientCache(
  queryClient: QueryClient,
  persister: CachePersister,
): void {
  queryClient.clear();
  void persister.removeClient();
}
